import * as yup from "yup"


export const submitAppSchema = yup.object().shape({
  url: yup.string().url().required(),
  email: yup.string().email().required(),
});

